import { render, staticRenderFns } from "./FinanceMyLoans.vue?vue&type=template&id=48be89e8"
import script from "./FinanceMyLoans.vue?vue&type=script&lang=js"
export * from "./FinanceMyLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports